
type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    id?: string | number;
};

export function HeartIcon({ width = 16, height = 16, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            className={className}
            style={style}
        >
            <path d="M8 3.41411L7.909 3.32818C7.13427 2.57012 6.09491 2.14333 5.011 2.13818C3.94843 2.13818 2.92927 2.55981 2.17727 3.3105C1.42526 4.0612 1.00185 5.07962 1 6.14218C1 8.29816 1.791 9.32716 5.326 12.1202L7.18247 13.5612C7.66353 13.9346 8.33647 13.9346 8.81753 13.5612L10.674 12.1202C14.209 9.32716 15 8.29816 15 6.14218C14.9981 5.07962 14.5747 4.0612 13.8227 3.3105C13.0707 2.55981 12.0515 2.13818 10.989 2.13818C9.90507 2.14333 8.86573 2.57012 8.091 3.32818L8 3.41411Z" />
        </svg>
    );
}

export default HeartIcon;